module.exports = __webpack_public_path__ + "static/national-2-web-medium-79b0f2e02cd8acfba197099c8f00866b.woff";